import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { LocaleEnum } from '../openapi/models';

@Injectable({ providedIn: 'root' })
export class LocaleInterceptor implements HttpInterceptor {
	constructor(private translateService: TranslateService) {}

	intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const localeHeader: string =
			localStorage.getItem('currentLang') || this.translateService.defaultLang || LocaleEnum.Hu;
		const clonedRequest = req.clone({
			setHeaders: {
				'Accept-Language': localeHeader,
			},
		});
		return next.handle(clonedRequest);
	}
}
